import React, { useState, useCallback, } from "react";
import { v4 as uuid } from "uuid";
import { TabbedContentStyled } from "./TabbedContentStyled";
import useModals from "../ModalsStack/useModals";
import ModalDelete from "../ModalsStack/ModalDelete";
var TabButton = function (_a) {
    var active = _a.active, index = _a.index, label = _a.label, onClick = _a.onClick;
    var handleClick = useCallback(function () {
        onClick(index);
    }, [index, onClick]);
    return (React.createElement("button", { onClick: handleClick, className: active ? "isActive" : "" }, label));
};
var MODAL_CHANGE_TITLE = "Are you sure you want to change tabs?";
var MODAL_CHANGE_NOTE = "Note: all unsaved changes will be lost.";
var TabbedContent = function (_a) {
    var tabLabels = _a.tabLabels, tabContent = _a.tabContent, _b = _a.showWarning, showWarning = _b === void 0 ? false : _b;
    var _c = useModals(), openModal = _c.openModal, closeModal = _c.closeModal;
    var _d = useState(0), activeTab = _d[0], setActiveTab = _d[1];
    var handleTabClick = useCallback(function (tabIndex) {
        if (!showWarning) {
            setActiveTab(tabIndex);
        }
        else {
            var modalId = uuid();
            openModal(modalId, "Modal title", React.createElement(ModalDelete, { modalId: modalId, title: MODAL_CHANGE_TITLE, note: MODAL_CHANGE_NOTE, deleteText: "Change", onDelete: function () { return setActiveTab(tabIndex); }, closeModal: function (modalId) { return closeModal(modalId); } }));
        }
    }, [closeModal, openModal, showWarning]);
    if (tabLabels.length > 0) {
        return (React.createElement(TabbedContentStyled, null,
            React.createElement("div", { className: "tabs" }, tabLabels.map(function (label, i) { return (React.createElement(TabButton, { key: "tab-button-" + i, index: i, label: label, active: activeTab === i, onClick: handleTabClick })); })),
            React.createElement("hr", { className: "tabs-bottom" }),
            React.createElement("div", { className: "tab-content" }, tabContent[activeTab])));
    }
    else {
        console.warn("No tabs to show.", tabLabels, tabContent);
        return React.createElement(React.Fragment, null);
    }
};
export default React.memo(TabbedContent);
//# sourceMappingURL=TabbedContent.js.map